import { SET_DEFAULT_ADDRESS } from "../Types";
import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  PHONE_AUTH,
  TC_CHECKED,
  REFRESH_TOKEN,
  SHOW_TOAST,
  STOP_TOAST,
  UPDATE_ONBOARDING_SUCESS,
  UPDATE_EDITED_DETAILS,
  UPLOAD_PROFILE_IMAGE,
  USER_VEHICLES_DATA,
  SET_SELECTED_VEHICLE_REF,
  UPDATE_USER_SETTINGS,
  MODIFY_TOKEN,
  SAVE_WORKSHOP_STANDARD,
} from "../Types/auth";

const initalState = {
  token: "",
  defaultAddressRef: "",
  defaultVehicleRef: "",
  selectedVehicleRef: "",
  tcChecked: false,
  settings: {
    notificationsEnabled: false,
    remindersEnabled: false,
    pricingSegment: "standard",
    workshopId: "",
  },
};

export function authReducer(state = initalState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return {
        ...state,
        ...action.data,
        settings: { ...state.settings, ...action.data.settings },
        selectedVehicleRef: action.data.defaultVehicleRef || "",
      };
    }
    case MODIFY_TOKEN: {
      return {
        ...state,
        ...action.data,
      };
    }
    case UPDATE_EDITED_DETAILS: {
      return { ...state, ...action.data };
    }
    case UPLOAD_PROFILE_IMAGE: {
      return { ...state, ...action.data };
    }
    case UPDATE_ONBOARDING_SUCESS: {
      return { ...state, ...action.data };
    }
    case SET_SELECTED_VEHICLE_REF: {
      return {
        ...state,
        selectedVehicleRef: action.data,
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initalState };
    }
    case TC_CHECKED: {
      return { ...state, tcChecked: action.data };
    }
    case REFRESH_TOKEN: {
      const { refreshToken } = action.body;
      return { ...state, token: refreshToken };
    }
    case PHONE_AUTH: {
      return { ...state, ...action.data };
    }
    case SET_DEFAULT_ADDRESS: {
      return { ...state, defaultAddressRef: action.data };
    }
    case UPDATE_USER_SETTINGS: {
      return { ...state, ...action.data };
    }
    case SAVE_WORKSHOP_STANDARD: {
      return {
        ...state,
        settings: {
          ...state.settings,
          pricingSegment: action.data,
        },
      };
    }
    default:
      return state;
  }
}

export function toaster(state = { toaster: 0 }, action) {
  switch (action.type) {
    case SHOW_TOAST: {
      const toaster = ++state.toaster;
      return {
        ...state,
        toaster,
        errorMessage: action.message,
        severity: action.severity || null,
      };
    }
    case STOP_TOAST: {
      const toaster = Math.max(0, --state.toaster);
      return { ...state, toaster };
    }
    default:
      return state;
  }
}
